export default __webpack_public_path__ + "static/media/slide-5.9619efc5.webp";